import React, { useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/checkout";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { T } from "@/constants/testIds";

export default function LeadCapture() {
  const [state, setState] = useState({ name: "", email: "", loading: false, ok: false });

  const submit = async (e) => {
    e.preventDefault();
    if (!state.email || !state.name) return;
    setState((s) => ({ ...s, loading: true }));
    try {
      await api.post("/leads", { name: state.name, email: state.email });
      setState({ name: "", email: "", loading: false, ok: true });
      toast.success("Inscrição confirmada. Em breve novidades do dossiê.");
    } catch (e) {
      setState((s) => ({ ...s, loading: false }));
      toast.error("Não foi possível salvar. Verifique o e-mail e tente novamente.");
    }
  };

  return (
    <section className="relative bg-[#070707] py-20 border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="h-[1px] w-10 bg-red-600" />
            <span className="eyebrow">Lista do editorial</span>
          </div>
          <h2 className="font-display font-black text-neutral-50 leading-[0.95] tracking-[-0.02em] text-3xl md:text-5xl">
            Receba atualizações de novas edições do{" "}
            <span className="text-red-600 italic">dossiê</span>.
          </h2>
          <p className="mt-5 text-neutral-500 text-[14px] max-w-md leading-relaxed">
            Enviamos apenas quando houver um novo capítulo documentado. Sem spam, sem partido.
          </p>
        </div>
        <motion.form
          onSubmit={submit}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative border border-white/10 bg-[#0a0a0a] p-6 md:p-8"
        >
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-red-500 mb-5">
            Inscrição editorial
          </div>
          <div className="grid grid-cols-1 gap-3">
            <Input
              data-testid={T.leadName}
              placeholder="Nome"
              value={state.name}
              onChange={(e) => setState((s) => ({ ...s, name: e.target.value }))}
              className="bg-black border-white/10 rounded-sm h-12 text-neutral-100 placeholder:text-neutral-600"
            />
            <Input
              data-testid={T.leadEmail}
              type="email"
              placeholder="E-mail"
              value={state.email}
              onChange={(e) => setState((s) => ({ ...s, email: e.target.value }))}
              className="bg-black border-white/10 rounded-sm h-12 text-neutral-100 placeholder:text-neutral-600"
            />
            <Button
              data-testid={T.leadSubmit}
              disabled={state.loading}
              type="submit"
              className="h-12 bg-red-600 hover:bg-red-700 rounded-sm font-mono tracking-[0.25em] text-[11px] uppercase"
            >
              {state.loading ? "Enviando..." : state.ok ? "Inscrito" : "Entrar na lista"}
            </Button>
          </div>
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-neutral-600 mt-5">
            Ao se inscrever, você concorda com nossa política de privacidade.
          </p>
        </motion.form>
      </div>
    </section>
  );
}
